module.exports = __webpack_public_path__ + "static/media/desktop-step1.5f8072b6.png";